import { Flex, MenuBookOutlinedIcon, Text } from '@shared/components';

export default function AllExamCourseAssignedOverlay() {
  return (
    <Flex
      sx={(theme) => ({
        flexDirection: 'column',
        py: theme.spacing(20),
        gap: theme.spacing(4),
        alignItems: 'center',
      })}
    >
      <MenuBookOutlinedIcon
        sx={(theme) => ({ fontSize: '100px', color: theme.palette.grey[400] })}
      />
      <Flex
        sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(2), alignItems: 'center' })}
      >
        <Text variant='h3'>หลักสูตรทั้งหมดได้ถูกเพิ่มเข้าศูนย์ทดสอบแล้ว</Text>
        <Text>ไม่มีหลักสูตรที่สามารถเพิ่มเข้าศูนย์ทดสอบได้อีก</Text>
      </Flex>
    </Flex>
  );
}
